import { EvasysActionsFactory } from '@evasys/shared/core';
import { SystemInfoModel } from '@evasys/globals/evasys/models/business/system-info.model';

const actionsFactory = new EvasysActionsFactory<SystemInfoModel>('SYSTEM_INFO');

export const { LoadPageActionSet, LoadOneActionSet, LoadManyActionSet, LoadActionSet } = actionsFactory.createActions();
